import { Component } from '@angular/core';
import { SkeletonLoaderComponent } from '../../skeleton-loader/skeleton-loader.component';

@Component({
  selector: 'app-skeleton-loader-reminder',
  templateUrl: './skeleton-loader-reminder.component.html',
  imports: [SkeletonLoaderComponent],
  standalone: true,
})
export class SkeletonLoaderReminderComponent {
  loopArray = Array.from({ length: 3 }, (_, i) => i + 1);

  constructor() {}
}
